import React from "react";

import AdminTopBar from "../components/AppBar";
import OthersScreen from "../screens/OthersScreen";

export default function MenuPage() {
  return (
    <div className="min-h-screen bg-slate-950 pb-24 text-white">
      <AdminTopBar handleAdd={() => {}} />

      <main className="mx-auto flex max-w-5xl flex-col px-4 py-6">
        <OthersScreen />
      </main>
    </div>
  );
}
